import Client from "./client";

/**
 * The app's text documents - terms, privacy policy, open source notices and
 * the API reference (see api/lib/documents.js).
 *
 * No access token on any of these. Two of them have to be readable before
 * anybody has an account, and the other two are not secret either.
 */

export const GetDocuments = () => {
    return new Promise((resolve, reject) => {
        Client.get("/api/public/documents").then((res) => {
            resolve(res.data.documents);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetDocument = (slug) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/public/documents/${slug}`).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong fetching that document." }),
                status: e.response?.status,
            });
        })
    })
}

// The raw file, for a link that opens in a new tab. Not fetched - handed to an
// href - so the large notices document never has to be parsed by the browser
// app at all.
export const documentRawUrl = (slug) => `/api/public/documents/${slug}?raw`;

// What version is running, for the About page. Null if the server can't say.
export const GetServerVersion = () => {
    return new Promise((resolve) => {
        Client.get("/api/public/version")
            .then((res) => resolve(res.data.version ?? null))
            .catch(() => resolve(null));
    })
}
